import type { AppRouteModule } from '/@/router/types';

import { LAYOUT2 } from '/@/router/constant';
import { router } from '/@/router';
import { t } from '@mcex/locale';
import { PackageEnum, PageEnum } from '/@/enums/pageEnum';
import { MenuCodeEnum } from '/@/enums/menuCodeEnum';
import { useDmpDroStoreWithOut } from '/@/store/modules/dmp/dro';
import { DroDetailType } from '/@/api/dmp/model/dro';

const dmp: AppRouteModule[] = [
  {
    path: `/${PackageEnum.dmp}`,
    name: 'DroManagePlatform',
    component: LAYOUT2,
    redirect: function (_to) {
      const routes = router.getRoutes();
      const route = routes.find((item) => item.name === 'DroManagePlatform');
      if (route?.children?.length) {
        return `/${PackageEnum.dmp}/${route.children[0].path}`;
      }
      return '/dmp/holding';
    },
    meta: {
      orderNo: 1,
      icon: 'menus-home|svg',
      title: t('DRO持仓看板'),
      hidePackage: true,
      package: PackageEnum.dmp,
    },
    children: [
      {
        path: 'holding',
        name: 'dmpHolding',
        component: () => import('/@/views/dmp/holding/index.vue'),
        meta: {
          title: '持仓列表',
          menuCodes: [MenuCodeEnum.dmpPositionList],
          hideChildrenInMenu: true,
        },
        children: [
          {
            path: 'detail_dro/:droCode?',
            name: 'DetailDro',
            component: () => import('/@/views/dmp/detail_dro/L1/index.vue'),
            meta: {
              title: t('routes.mcex.droDetail'),
              currentActiveMenu: PageEnum.DMP_HOLDING,
              menuCodes: [MenuCodeEnum.dmpPositionListDroDetail],
            },
            beforeEnter: async (to) => {
              const tradEtpStore = useDmpDroStoreWithOut();
              tradEtpStore.setDroInfo({
                ...tradEtpStore.droDetail,
                droCode: to.params.droCode as string,
              } as DroDetailType);
              tradEtpStore.fetchDroData(to.params.droCode as string);
              return true;
            },
          },
        ],
      },
      {
        path: 'pledge',
        name: 'dmpPledge',
        component: () => import('/@/views/dmp/pledge/index.vue'),
        meta: {
          title: '质押记录',
          menuCodes: [MenuCodeEnum.dmpPledgeRecord],
        },
      },
      {
        path: 'sale',
        name: 'dmpSale',
        component: () => import('/@/views/dmp/sale/index.vue'),
        meta: {
          title: '出售记录',
          menuCodes: [MenuCodeEnum.dmpSellRecord],
        },
      },
      {
        path: 'packet',
        name: 'dmpPacket',
        component: () => import('/@/views/dmp/packet/index.vue'),
        meta: {
          title: '封包记录',
          menuCodes: [MenuCodeEnum.dmpPackageRecord],
        },
      },
    ],
  },
  {
    path: `/${PackageEnum.dmp}/finance-manage`,
    name: 'dmpFinance',
    component: LAYOUT2,
    meta: {
      orderNo: 1,
      icon: 'menus-finance|svg',
      title: t('资金管理'),
      package: PackageEnum.dmp,
      hidePackage: true,
      hideMenu: false,
      menuCodes: [MenuCodeEnum.dmpFundFlow], // TODO: 待优化为独立Code
    },
    children: [
      {
        path: 'finance',
        name: 'dmpFinance',
        component: () => import('/@/views/dmp/finance_flow/index.vue'),
        meta: {
          title: '资金流水',
          menuCodes: [MenuCodeEnum.dmpFundFlow],
        },
      },
    ],
  },
];

export default dmp;
